<script setup lang="ts">
import { computed } from 'vue'
import GwBtn from '@/components/lib/GwBtn/GwBtn.vue'

export type Props = {
  selected?: boolean
  indeterminate?: boolean
  indeterminateIcon?: string
  icons?: [string, string]
}

const props = withDefaults(defineProps<Props>(), {
  icons: () => ['mdi-checkbox-blank-outline', 'mdi-checkbox-marked'],
  indeterminateIcon: 'mdi-minus-box',
})

const emit = defineEmits(['change'])

const icon = computed(() => {
  if (props.indeterminate) return props.indeterminateIcon
  return props.selected ? props.icons[1] : props.icons[0]
})

const onChange = () => emit('change', props.selected)
</script>

<template>
  <GwBtn
    :icon
    variant="btn_text_grey_primary"
    :active="props.selected"
    @click="onChange"
  />
</template>
